import React, { useRef, useEffect, useMemo } from 'react'
import { object, bool } from 'prop-types'
import isEmpty from 'lodash/isEmpty'
import { Box, styled } from '@mui/material'
// import { useMyStore } from '@hooks/useMyStore'
import useStoreLocatorContext from '@context/storeLocatorContext/useStoreLocatorContext'
import '../../assets/css/components/store-locator/map-locations-list.sass'
import StoreListDetail from '../StoreListDetail/StoreListDetail'
import { scrollToSelectedMarker } from './map-locations-list'

const StoreWrapper = styled('div')(({ theme, selected }) => ({
  cursor: 'pointer',
  margin: 16,
  marginBottom: 0,
  '& > div': {
    ...(selected && { borderColor: theme.palette.primary.main }),
  },
}))

const StyledStoreContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  marginBottom: '21px',
  div: {
    '& > .MuiPaper-root': {
      borderColor: `1.5px solid ${theme.palette.primary.main}`,
    },
  },
}))

const MapLocationMyStore = ({ showRatings, specialClosings }) => {
  const stores = useStoreLocatorContext(state => state.stores)
  const selectStore = useStoreLocatorContext(state => state.selectStore)
  const selectedStore = useStoreLocatorContext(state => state.selectedStore)
  const myStoreInContext = useStoreLocatorContext(state => state.myStore)
  const markers = useStoreLocatorContext(state => state.markers)
  const refSelectedMarker = useRef()

  useEffect(() => {
    if (selectedStore && refSelectedMarker.current) {
      scrollToSelectedMarker(refSelectedMarker)
    }
  }, [selectedStore, myStoreInContext])

  useEffect(() => {
    if (stores && myStoreInContext) {
      const myStore = stores.find(store => store.storeNumber === myStoreInContext.storeNumber)
      if (myStore) {
        selectStore(myStore.storeNumber)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myStoreInContext, selectStore])

  const mark = useMemo(() => stores?.find(store => store.storeNumber === myStoreInContext?.storeNumber), [
    stores,
    myStoreInContext,
  ])

  if (!mark) return null

  const storeDetails = {
    city: mark?.city || mark?.storeCity,
    // distance: mark?.distance,
    hours: mark?.hours || mark?.storeRegularHours,
    name: mark?.name || mark?.storeName,
    phone:
      mark?.phone?.replace('/', '-') ||
      mark?.phoneNumber?.replace('/', '-') ||
      mark?.storePhoneNumber?.replace('/', '-'),
    selectedRatings: mark?.ratings?.lifetime || {},
    state: mark?.state || mark?.storeState,
    storeNumber: mark.storeNumber ? `${mark.storeNumber}` : null,
    title: mark?.title || mark?.storeTitle || mark?.address1,
    types: mark?.types || [],
    zip: mark?.zip || mark?.storeZip,
  }

  const markerIsSelected = !isEmpty(selectedStore) && selectedStore?.storeNumber === mark?.storeNumber
  const isMyPreferredStore = true

  return (
    <Box
      key={`${mark.title}|${mark.name}`}
      style={{ display: 'flex', flexDirection: isMyPreferredStore ? 'column' : 'column-reverse' }}
    >
      <StyledStoreContainer>
        <StoreWrapper
          {...(markerIsSelected && { ref: refSelectedMarker })}
          selected={markerIsSelected || isMyPreferredStore}
          role="button"
          // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
          tabIndex="0"
          onClick={() => selectStore(mark.StoreNumber)}
          onKeyDown={e => {
            if (e.keyCode === 13) selectStore(mark.StoreNumber)
          }}
        >
          <StoreListDetail
            isSelected={markerIsSelected}
            letter={markers?.[mark.storeNumber]?.letter}
            specialClosings={specialClosings}
            showRatings={!!showRatings}
            storeDetails={storeDetails}
            myStore
            isDefaultUserStore
            noStoreNameLink
          />
        </StoreWrapper>
      </StyledStoreContainer>
    </Box>
  )
}

MapLocationMyStore.propTypes = {
  showRatings: bool,
  specialClosings: object,
}

export default MapLocationMyStore
